<template>
  <div>
    <Preview />
  </div>
</template>

<script>
import LoadingSkeleton from "@/components/generic/LoadingSkeleton";

const Preview = () => ({
  component: import('@/components/center_widgets/Preview'),
  loading: LoadingSkeleton,
  timeout: 200
})

export default {
  name: 'TournamentView',
  components: { Preview },
}
</script>
